export default __webpack_public_path__ + "static/media/down_arrow.ef0644e5.png";